import OperationsController from "../adapters/method.controller";

const updateMethod = async(payload) =>{
    const {id, name, pKey, sKey} = payload
    payload = {
        id: id, 
        name: name,
        pKey: pKey,
        sKey: sKey,
    }
    const response = await OperationsController.updateMethod(payload)
    return response;
}


export default updateMethod;